import React from 'react';
import { connect } from 'react-redux';
import { GenericObject, Permission } from 'v2/models';
import SearchViewRoutes from './SearchViewRoutes';
import { hasActivePermissions } from 'v2/utils/permissions';
import BackgroundImages from 'v2/common/Background/BackgroundImages';
import NoActiveSearchesSplash from 'v2/common/NoActiveSearchesSplash/NoActiveSearchesSplash';

interface SearchViewContainerStateProps {
  permissions: { [key: string]: Permission };
}

const SearchViewContainer = ({
  permissions,
}: SearchViewContainerStateProps) => {
  if (!hasActivePermissions(permissions)) {
    return (
      <div className="mt-5 container-xl fix-bg-images">
        <BackgroundImages />
        <NoActiveSearchesSplash />
      </div>
    );
  }

  return <SearchViewRoutes permissions={permissions} />;
};

const mapStateToProps = (
  state: GenericObject
): SearchViewContainerStateProps => {
  return {
    permissions: state.permissions.permissions,
  };
};
export default connect<SearchViewContainerStateProps>(mapStateToProps)(
  SearchViewContainer
);
